export default "/_next/static/chunks/fonts/Montserrat-Thin-latin-20cabcf963f415c3d3cec7f22cde3c96.woff2";